import { render } from "./BottomButton.vue?vue&type=template&id=1fef0d56&scoped=true"
import script from "./BottomButton.vue?vue&type=script&lang=js"
export * from "./BottomButton.vue?vue&type=script&lang=js"

import "./BottomButton.vue?vue&type=style&index=0&id=1fef0d56&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fef0d56"]])

export default __exports__